export const FALLBACK_PLACEHOLDER =
  'data:image/svg+xml,' +
  encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" width="400" height="600" viewBox="0 0 400 600"><defs><linearGradient id="g" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" style="stop-color:#e0e7ff"/><stop offset="50%" style="stop-color:#c7d2fe"/><stop offset="100%" style="stop-color:#a5b4fc"/></linearGradient></defs><rect width="400" height="600" fill="url(#g)"/><text x="200" y="280" text-anchor="middle" font-family="system-ui,sans-serif" font-size="48" fill="#6366f1">📚</text><text x="200" y="330" text-anchor="middle" font-family="system-ui,sans-serif" font-size="14" fill="#818cf8">Image unavailable</text></svg>',
  )

export const handleImgError = (e: React.SyntheticEvent<HTMLImageElement>) => {
  const target = e.currentTarget
  if (target.src !== FALLBACK_PLACEHOLDER) {
    target.src = FALLBACK_PLACEHOLDER
    target.style.objectFit = 'cover'
  }
}
